import { yupResolver } from '@hookform/resolvers/yup';
import { useBooking } from 'hooks';
import { FC, PropsWithChildren } from 'react';
import { useForm, FormProvider, FieldErrors } from 'react-hook-form';

import { patientInformationFormSchema, PatientInformationFormSchemaValidated } from './schema';

const resolver = yupResolver(patientInformationFormSchema);

interface Props {
    onSubmit: (data: PatientInformationFormSchemaValidated) => void;
    onError: (errors: FieldErrors) => void;
}

const PatientInformationForm: FC<PropsWithChildren<Props>> = ({ onSubmit, onError, children }) => {
    const { booking } = useBooking();

    const form = useForm<PatientInformationFormSchemaValidated>({
        criteriaMode: 'all',
        defaultValues: booking.patientInformation ?? {
            dateOfBirth: undefined,
            address: undefined,
            addressCount: undefined,
            city: undefined,
            email: undefined,
            firstName: undefined,
            guardianCheck: undefined,
            lastName: undefined,
            phoneNumber: undefined,
            phoneType: undefined,
            sex: undefined,
            state: undefined,
            zip: undefined,
        },
        mode: 'onBlur',
        resolver,
        shouldFocusError: true,
    });

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit, onError)}>
                <button type="submit" disabled hidden aria-description="Prevent implicit submission of the form" />
                {children}
            </form>
        </FormProvider>
    );
};

export { PatientInformationForm };
